export const artistKeys = {
    all: ['artist'],
    detail: (id) => [...artistKeys.all, 'detail', id],
    mailData: (id) => [...artistKeys.detail(id), 'mail'],
    baseData: (id) => [...artistKeys.detail(id), 'base'],
    privateMail: (id) => [...artistKeys.detail(id), 'private-mail'],
    privateMails: () => [...artistKeys.all, 'private-mails'],
    rechteData: (id) => [...artistKeys.detail(id), 'rechte'],
    locations: (id) => [...artistKeys.detail(id), 'locations'],
    worktimes: (id) => [...artistKeys.detail(id), 'worktimes'],
    worktime: (id, worktimeId) => [...artistKeys.worktimes(id), worktimeId],
}

/**
 * Matches the queries of the mail mask of every artist: sender data, personal address and the admin's list of
 * all personal addresses. A change of a studio address can alter all of them, so it invalidates by this predicate.
 */
export const isArtistMailQuery = ({ queryKey }) => {
    const [root, scope, , part] = queryKey;
    return root === artistKeys.all[0] && ((scope === 'detail' && (part === 'mail' || part === 'private-mail')) || scope === 'private-mails');
};
